module.exports = __webpack_public_path__ + "static/media/speechBaloon.7288473a.svg";